export default __webpack_public_path__ + "static/media/person-default.c9020611.png";